import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { verifyParcelExistence, getAllClearingItems } from '../../../actions/ssmActions';
import { TextField }  from '@material-ui/core';
import { useTranslation } from 'react-i18next';

function ScanInput() {
  const dispatch = useDispatch();
  const {t} = useTranslation('storageScan');
  
  const storageManagement = useSelector(state => state.storageScanManagement);
  const batchSendNo = storageManagement.batchSendNo;

  const [input, setInput] = useState('');
  const [show, setShow] = useState(false);
  const [parcelExistenceMsg, setParcelExistenceMsg] = useState('');
  const [value, setValue] = useState('');

  return (
    <div style={{ marginBottom: '10px'}}>
      <TextField
        id="outlined-full-width"
        placeholder={t('click_to_scan')}
        fullWidth
        margin="normal"
        variant="outlined"
        value={value}
        inputprops={{
          style: {
            padding: '8px'
          }
        }}
        onChange={(e) => {
          setInput(e.target.value);
          setShow(false);
          setValue(e.target.value);
        }}
        onKeyUp={(e) => {
          if (e.key === 'Enter') {
            dispatch(verifyParcelExistence(input, batchSendNo))
            .then((res) => {
              setShow(true);
              setValue('');
              dispatch(getAllClearingItems(batchSendNo));
              const updated = res.data.updated;
              if(updated) {
                setParcelExistenceMsg(t("success"));
              } else {
                setParcelExistenceMsg(t("scan_repeated"));                
              }
            })
            .catch(() => {
              setParcelExistenceMsg(t("wrong_ant_parcel"));
              setShow(true);
              setValue('');
            })
          }}}
      />
      { show && <div >{t('ant_parcel')} { input } {t('scanner_result')}{ parcelExistenceMsg }</div> }
    </div>
  );
}
export default ScanInput;